module.exports = __webpack_public_path__ + "static/media/vehicle icon.29ce417c.svg";